import React, { useEffect, useState } from 'react';
import { Button, Modal, notification, Flex, Spin } from 'antd';
import {
  EditOutlined,
  FileDoneOutlined,
  FileExcelOutlined,
} from '@ant-design/icons';
import { contracts } from '../api';
import { convertDate, extractContract } from './usefulFunctions';
import ContractDetail from './ContractDetail';
import PoDrawer from '../projectPages/PoDrawer';
import RejectionPopup from './RejectionPopup';
import {userRole, employeeId} from '../../GetRole.utils';


const PoDetail = ({ id }) => {
  const [poData, setPoData] = useState([]);
  const [title, setTitle] = useState('');
  const [showBtn, setShowBtn] = useState(false);
  const [contractStatus, setContractStatus] = useState();
  const [activationDate, setActivationDate] = useState();
  const [expiryDate, setExpiryDate] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const [isRejectionModelOpen, setIsRejectionModelOpen] = useState(false);
  const [rejectionKey, setRejectionKey] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [apiHit, setApiHit] = useState(false);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
      style: {
        padding: '9px 24px',
      },
    });
  };

  const showRejectionModel = (key) => {
    setRejectionKey(key);
    setIsRejectionModelOpen(true);
  };

  const handleRejectionPopupCanacel = () => {
    setRejectionKey(null);
    setIsRejectionModelOpen(false);
  };

  const showModal = (key) => {
    setSelectedKey(key);
    setIsModalOpen(true);
    setApiHit(!apiHit);
  };

  const handlePopupCancel = () => {
    setSelectedKey(null);
    setIsModalOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    try {
      contracts
        .getContractsData(id)
        .then((res) => {
          const data = res.data[0].contractData;
          setTitle(data?.poNumber);
          setContractStatus(data.cStatus);
          setActivationDate(data.activationDate);
          setExpiryDate(data.expiryDate);

          const arr = [
            {
              label: 'Client Name :',
              labelValue: data.client.legalEntityName,
              key: 'client',
              redirection: true,
              redirectionURL: `/clients/${data.client.clientId}`,
            },
            {
              label: 'Contract Type :',
              labelValue: extractContract(data.contractType),
              key: 'contractType',
            },
            {
              label: 'SOW Number :',
              labelValue: data?.sowNumber ? data?.sowNumber : '-',
              key: 'sowNumber',
            },
            {
              label: 'Project Name :',
              labelValue: data.project.projectName,
              key: 'project',
              redirection: true,
              redirectionURL: `/projects/${data?.project?.projectId}`,
            },
            {
              label: 'Shipping Address :',
              labelValue: data?.shipTo,
              key: 'shipTo',
            },
            { 
              label: 'Billing Address :',
              labelValue: data.billTo,
              key: 'billTo',
            },
            {
              label: 'Total Amount :',
              labelValue: data?.totalAmount,
              key: 'totalAmount',
            },
            {
              label: 'PO File :',
              labelValue: data.fileName,
              labelUrl: data?.fileUrl,
              key: 'fileName',
            },
            {
              label: 'Start Date :',
              labelValue: data.activationDate ? data.activationDate : '-',
              key: 'activationDate',
            },
            {
              label: 'End Date :',
              labelValue: data.expiryDate ? data.expiryDate : '-',
              key: 'expiryDate',
            },
            {
              label: 'Last Updated On :',
              labelValue: data.updatedAt,
              key: 'updatedAt',
            },
            {
              label: 'Status :',
              labelValue: data.cStatus,
              key: 'cStatus',
            },
          ];
          setPoData(arr);
          setLoading(false);
        })
        .catch((error) => console.error('Error fetching data:', error));
    } catch (err) {
      console.error('Error fetching data:', err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [showBtn, isModalOpen, isRejectionModelOpen]);

  const handleApproval = (status, succcessfulMessage) => {
    const postData = {
      cStatusId: status,
      createdBy: employeeId, 
    };
    setLoadings(true);
    contracts
      .updateContractsData(id, postData)
      .then((res) => {
        openNotificationWithIcon('success', succcessfulMessage);
        setShowBtn((prevshowBtn) => !prevshowBtn);
        setLoadings(false);
        setIsRejectionModelOpen(!isRejectionModelOpen);
      })
      .catch((err) => {
        console.log(err);
        setLoadings(false);
        openNotificationWithIcon('error', err.response.data.message);
      });
  };

  const approvalButtons = () => {
    switch (contractStatus) {
      case 'draft':
        return (
          <>
            {userRole !== 'finance' && (
              <Button
                type="primary"
                icon={<FileDoneOutlined />}
                style={{
                  backgroundColor: '#52c41a',
                }}
                loadings={loadings}
                onClick={() => handleApproval(2, 'Contract sent for Approval')}
              >
                Send For Approval
              </Button>
            )}
          </>
        );

      case 'pendingapproval':
        return (
          <>
             {userRole !== 'bdTeam' && (
              <>
                <Button
                  onClick={() => showRejectionModel('approve')}
                  type="primary"
                  icon={<FileDoneOutlined />}
                  style={{
                    backgroundColor: '#13c2c2',
                  }}
                >
                  Approve
                </Button>
                <Modal
                  title={'Add Comment'}
                  visible={isRejectionModelOpen && rejectionKey === 'approve'}
                  onCancel={handleRejectionPopupCanacel}
                  footer={null}
                >
                  <RejectionPopup
                    type={'Approve'}
                    hide={setIsRejectionModelOpen}
                    id={id}
                    activationDate={activationDate}
                    expiryDate={expiryDate}
                  />
                </Modal>

                <Button
                  onClick={() => showRejectionModel('reject')}
                  type="primary"
                  icon={<FileExcelOutlined />}
                  style={{
                    backgroundColor: '#f5222d',
                  }}
                >
                  Reject
                </Button>
                <Modal
                  title={'Add Comment'}
                  visible={isRejectionModelOpen && rejectionKey === 'reject'}
                  onCancel={handleRejectionPopupCanacel}
                  footer={null}
                >
                  <RejectionPopup
                    type={'Reject'}
                    hide={setIsRejectionModelOpen}
                    id={id}
                    activationDate={activationDate}
                    expiryDate={expiryDate}
                  />
                </Modal>
              </>
            )}
          </>
        );

      default:
        return <></>;
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            height: '540px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spin />
        </div>
      ) : (
        <ContractDetail
          contractData={poData}
          isRejectionModelOpen={isRejectionModelOpen}
          title={`PO Number : ${title ? title : 'N/A'}`}
          popUpComponent={
            <Flex gap={5}>
              {(contractStatus === 'draft' ||
                contractStatus === 'pendingapproval' ||
                contractStatus === 'inactive') &&
                userRole !== 'finance' && (
                <>
                  <Button
                    onClick={() => showModal(id)}
                    type="primary"
                    icon={<EditOutlined />}
                  >
                    EDIT
                  </Button>
                  <PoDrawer
                    open={isModalOpen && selectedKey === id}
                    contractId={id}
                    onClose={handlePopupCancel}
                  />
                </>
              )}
              {approvalButtons()}
            </Flex>
          }
        />
      )}
    </>
  );
};

export default PoDetail;
